module.exports = __webpack_public_path__ + "img/moneyin.5424199e.jpg";